import {
    // archiveUrl,
    // certificateUrl,
    // deleteCertificateUrl,
    // restoreCertificateUrl,
    // sendCertEmailUrl,
    askApi,
    getPreloadUrl,
    id06OrderUrl,
    exportSsgUrl,
    prepareCertificateUrl,
    statisticsUrl,
    apiDomain,
    apiDomainEmploy,
} from '../endpoints';
import { clearExpertiseBreakdownCache } from '@composables/useExpertiseBreakdown';

export function getCertificates(filter) {
    const isEmploy = window.location.pathname.includes('employ');

    return new Promise((resolve, reject) => {
        askApi
            .get(`${isEmploy ? apiDomainEmploy : apiDomain}/certificates`, { params: filter })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
            })
            .catch(() => {
                // :)
                reject();
            });
    });
}

export function getPreloads() {
    return new Promise((resolve) => {
        askApi.get(getPreloadUrl).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function uploadCertificateFile(payload) {
    return new Promise((resolve, reject) => {
        askApi
            .post(prepareCertificateUrl, payload, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
            })
            .catch(() => {
                reject({
                    status: 'Error',
                    title: 'Ogiltig fil',
                    message: 'Någonting gick fel vid uppladdningen av din fil, kontrollera filen och försök igen.',
                });
            });
    });
}

export function createCertificate(payload) {
    const isEmploy = window.location.pathname.includes('employ');

    return new Promise((resolve, reject) => {
        askApi
            .post(`${isEmploy ? apiDomainEmploy : apiDomain}/certificates`, payload)
            .then((response) => {
                if (response.status === 200) {
                    clearExpertiseBreakdownCache();
                    resolve(response.data);
                }
            })
            .catch(() => {
                reject({
                    status: 'Error',
                    title: 'Tekniska bekymmer!',
                    message: 'Någonting gick fel, vänligen försök igen senare eller kontakta Cervd.',
                });
            });
    });
}

export function deleteCertifications(payload) {
    const isEmploy = window.location.pathname.includes('employ');
    let endpoint = `${isEmploy ? apiDomainEmploy : apiDomain}/certificates`;

    if (payload.method === 'hard-delete') {
        endpoint = `${isEmploy ? apiDomainEmploy : apiDomain}/certificates/force`;
    }

    delete payload.method;

    return new Promise((resolve) => {
        askApi.delete(endpoint, { data: payload }).then((response) => {
            if (response.status === 200) {
                clearExpertiseBreakdownCache();
                resolve(response.data);

                window.dispatchEvent(new CustomEvent('pagination.update.data'));
            }
        });
    });
}

export function restoreCertificate(payload) {
    const isEmploy = window.location.pathname.includes('employ');

    return new Promise((resolve) => {
        askApi.post(`${isEmploy ? apiDomainEmploy : apiDomain}/certificates/restore`, payload).then((response) => {
            if (response.status === 200) {
                clearExpertiseBreakdownCache();
                resolve(response.data);
                window.dispatchEvent(new CustomEvent('pagination.update.data'));
            }
        });
    });
}

export function certificateStatistics(payload) {
    return new Promise((resolve) => {
        askApi.get(statisticsUrl, { params: { months: payload.months } }).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function sendCertAsEmail(payload) {
    const isEmploy = window.location.pathname.includes('employ');

    return new Promise((resolve) => {
        askApi.post(`${isEmploy ? apiDomainEmploy : apiDomain}/certificates/send`, payload).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function getArchive() {
    const isEmploy = window.location.pathname.includes('employ');

    return new Promise((resolve) => {
        askApi.get(`${isEmploy ? apiDomainEmploy : apiDomain}/certificates/archive`).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function purchaseID06(payload) {
    return new Promise((resolve) => {
        askApi.post(id06OrderUrl, payload).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}
export function exportSsg(payload) {
    return new Promise((resolve) => {
        askApi.post(exportSsgUrl, payload).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

// Excel-rapporten för Roller-vyn — svaret är själva xlsx-filen
export function getExpertiseReport(params) {
    return askApi.get(route('v2.employ.certificates.expertises.report'), {
        params,
        responseType: 'blob',
        headers: { Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
    });
}
